import type { StateAction } from "@entrilia/shared/types";
import type { DescriptiveDateRange } from "@entrilia/shared/utilities/dateFilterHelper";
import {
  anytime,
  last3Months,
  last12Months,
  last30Days,
  lastSevenDays,
} from "@entrilia/shared/utilities/dateFilterHelper";
import type { SearchInvestorCommunicationsRequest } from "../../api/types/investorCommunicationsTypes";

export const NEWS_PAGE_SIZE = 7;
export const NEWS_MOBILE_PAGE_SIZE = 5;
export const LATEST_NEWS_COUNT = 2;

export const newsDateRanges: DescriptiveDateRange[] = [anytime, lastSevenDays, last30Days, last3Months, last12Months];

export interface NewsPageState {
  categoryExternalId: string | undefined;
  dateRange: DescriptiveDateRange | undefined;
  searchTerm: string;
  pageIndex: number;
}

export const initialNewsPageState: NewsPageState = {
  categoryExternalId: undefined,
  dateRange: undefined,
  searchTerm: "",
  pageIndex: 0,
};

export const setCategoryAction =
  (categoryExternalId: string | undefined): StateAction<NewsPageState> =>
  (state) => ({ ...state, categoryExternalId, pageIndex: 0 });

export const setDateRangeAction =
  (dateRange: DescriptiveDateRange): StateAction<NewsPageState> =>
  (state) => ({ ...state, dateRange, pageIndex: 0 });

export const setSearchTermAction =
  (searchTerm: string): StateAction<NewsPageState> =>
  (state) => ({ ...state, searchTerm, pageIndex: 0 });

export const clearFiltersAction: StateAction<NewsPageState> = (state) => ({
  ...state,
  categoryExternalId: undefined,
  dateRange: undefined,
  pageIndex: 0,
});

export const isAnyNewsFilterApplied = (state: NewsPageState): boolean =>
  state.categoryExternalId !== undefined || state.dateRange?.from !== undefined || state.dateRange?.to !== undefined;

export const setPageIndexAction =
  (pageIndex: number): StateAction<NewsPageState> =>
  (state) => ({ ...state, pageIndex });

export const mapNewsPageStateToRequest = (
  state: NewsPageState,
  pageSize = NEWS_PAGE_SIZE
): SearchInvestorCommunicationsRequest => ({
  paging: { page: state.pageIndex, size: pageSize, totals: true },
  categoryExternalIds: state.categoryExternalId ? [state.categoryExternalId] : undefined,
  publishedAtFrom: state.dateRange?.from?.toISOString(),
  publishedAtTo: state.dateRange?.to?.toISOString(),
  searchTerm: state.searchTerm.trim() || undefined,
});
